function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0sc{fill:#F0F0F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0sc",
  points: "7.12,15.94 4.63,13.45 12.34,5.74 15.28,8.67 22.26,1.69 24.76,4.19 15.28,13.66 12.34,10.72  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0sc",
  points: "26.45,7.05 19.4,0 26.45,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0sc",
  points: "28.8,21.75 0,21.75 0,0 1.18,0 1.18,20.57 28.8,20.57  "
}));

var SvgMenuStatistic = function SvgMenuStatistic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.8 21.75",
    style: {
      enableBackground: "new 0 0 28.8 21.75"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuStatistic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu_Statistic.1eb33d03.svg";
export { ForwardRef as ReactComponent };